module.exports = __webpack_public_path__ + "img/canales-edeq.2bda3788.svg";